import { useFormikContext } from 'formik';
import { Label } from '@antimatterhq/ui/components/label';
import type { DataSourceFieldSchemaValues } from '@/zod/schemas/dataSource/DataSourceField';
import { FormError, FormTextarea } from '@/components/form/form';

export default function LiteralTab() {
  const { values, handleChange } =
    useFormikContext<DataSourceFieldSchemaValues>();

  return (
    <div className="mt-4">
      <Label htmlFor="literal" id="literal-label" required>
        Enter a literal
      </Label>
      <FormTextarea
        placeholder="Enter your JSON or string here"
        value={values.literal}
        onChange={handleChange}
        className="min-h-[100px]"
        name="literal"
        aria-labelledby="literal-label"
      />
      <FormError name="literal" />
    </div>
  );
}
